import React from "react";
import { connect, ConnectedProps } from "react-redux";

import { generals } from "../../../../assets/images/generals";
import { icons } from "../../../../assets/images/icons";
import { openContentPopup } from "../../../../store/actions";
import { UPGRADES } from "../../../../lib/enums";
import DialogButton from "../../../Common/DialogButton";
import { Upgrade } from "../../../../lib/types";

interface IProps {
  typeId: number;
  typeName: string;
  sendToLabyrinth?: boolean;
  zeroGenerals: boolean;
}

const mapStateToProps = (state: any) => ({
  credits: state.governorate.player.credits,
  purchaseGeneral: state.governorate.upgrades
    .find((u: Upgrade) => u.id === UPGRADES.PurchaseGeneral)
})

const mapDispatchToProps = (dispatch: any) => ({
  openContentPopupDispatch:
    (contentPopupOptions: any) => dispatch(openContentPopup(contentPopupOptions)),
})

const connector = connect(mapStateToProps, mapDispatchToProps);

const GeneralEmptyCard = ({
  typeId,
  typeName,
  sendToLabyrinth,
  zeroGenerals,
  credits,
  purchaseGeneral,
  openContentPopupDispatch
}: IProps & ConnectedProps<typeof connector>) => (
  <div className="col-sm-6 col-md-3 person-col">
    <div className="person js-parent-select grey-wrap match-height">
      <img
        src={generals[`general${typeId}`]}
        width={60}
        height={70}
        alt="general portrait"
        className="photo grey"
      />
      <h3 className="name"/>
      <h4 className="subname h3">{typeName}</h4>

      {!zeroGenerals
        ? <>
          <p>
          You don't have {typeName} in your crew.<br/><br/>
          Try to find the general in labyrinth.
        </p>
          {sendToLabyrinth && <p>
            <a
              onClick={() => openContentPopupDispatch({
                name: "Labyrinth",
                title: "Labyrinth",
                icon: "labyrint"
              })}
              className="btn btn-blank btn-sm"
            >
              Go to labyrinth
            </a>
          </p>}
        </>
        : <p>
          You don't have {typeName} in your crew.<br/><br/>
          Continue in tutorial to get your first general.
        </p>}
      <p className="">Or you can buy him</p>
      <DialogButton
        dialogOptions={{
          name: "PurchaseUpgrade",
          header: "Purchase general",
          id: UPGRADES.PurchaseGeneral,
          params: { gtid: typeId },
          question: "Do you want to buy new general?",
          purchasable: !(credits < purchaseGeneral.price),
          price: purchaseGeneral.price
        }}
      >
        GET <img src={icons.credit} alt=""/>
      </DialogButton>
    </div>
  </div>
)

export default connector(GeneralEmptyCard);
